module.exports = __webpack_public_path__ + "img/keyboard.614db2b2.png";